import { Subject, Observable } from 'rxjs';

export abstract class DataSource {

  protected onChangedSource = new Subject<any>();
  protected onAddedSource = new Subject<any>();
  protected onUpdatedSource = new Subject<any>();
  protected onRemovedSource = new Subject<any>();

  public abstract getAll(): Promise<any>;
  public abstract getElements(): Promise<any>;
  // This method is a replica of getElements method, only
  // difference being it doesnt apply filtering on rows which are
  // newly added as they get filtered out and then add new operation fails
  public abstract getElementsWithCustomFilter(): Promise<any>;
  public abstract getSort(): any;
  public abstract getFilter(): any;
  public abstract getFilterPromise(): any;
  public abstract getFilteredAndSorted(): Promise<any>;
  public abstract getPaging(): any;
  public abstract count(): number;

  public refresh() {
    this.emitOnChanged('refresh');
  }

  public load(data: any[]): Promise<any> {
    this.emitOnChanged('load');
    return Promise.resolve();
  }

  public onChanged(): Observable<any> {
    return this.onChangedSource.asObservable();
  }

  public onAdded(): Observable<any> {
    return this.onAddedSource.asObservable();
  }

  public onUpdated(): Observable<any> {
    return this.onUpdatedSource.asObservable();
  }

  public onRemoved(): Observable<any> {
    return this.onRemovedSource.asObservable();
  }

  public prepend(element: any): Promise<any> {
    this.emitOnAdded(element);
    this.emitOnChangedWithCustomFilter('prepend', true);
    return Promise.resolve();
  }

  public insert(position: number , element: any): Promise<any> {
    this.emitOnAdded(element);
    this.emitOnChanged('prepend');
    return Promise.resolve();
  }

  public append(element: any): Promise<any> {
    this.emitOnAdded(element);
    this.emitOnChanged('append');
    return Promise.resolve();
  }

  public add(element: any): Promise<any> {
    this.emitOnAdded(element);
    this.emitOnChanged('add');
    return Promise.resolve();
  }

  public remove(element: any): Promise<any> {
    this.emitOnRemoved(element);
    this.emitOnChangedWithCustomFilter('remove', false);
    return Promise.resolve();
  }

  public removeNewRow(element: any): Promise<any> {
    this.emitOnRemoved(element);
    this.emitOnChangedWithCustomFilter('remove', false, true);
    return Promise.resolve();
  }

  public update(element: any, values: any): Promise<any> {
    this.emitOnUpdated(element);
    this.emitOnChanged('update');
    return Promise.resolve();
  }

  public empty(): Promise<any> {
    this.emitOnChanged('empty');
    return Promise.resolve();
  }

  public setSort(conf: any[], doEmit?: boolean) {
    if (doEmit) {
      this.emitOnChanged('sort');
    }
  }

  public setFilter(conf: any[], andOperator?: boolean, doEmit?: boolean) {
    if (doEmit) {
      this.emitOnChanged('filter');
    }
  }

  public addFilter(fieldConf: {}, andOperator?: boolean, doEmit?: boolean) {
    if (doEmit) {
      this.emitOnChanged('filter');
    }
  }

  public setPaging(page: number, perPage: number, doEmit?: boolean) {
    if (doEmit) {
      this.emitOnChanged('paging');
    }
  }

  public setPage(page: number, doEmit?: boolean) {
    if (doEmit) {
      this.emitOnChanged('page');
    }
  }

  protected emitOnRemoved(element: any) {
    this.onRemovedSource.next(element);
  }

  protected emitOnUpdated(element: any) {
    // this.onUpdatedSource.next(element);
  }

  protected emitOnAdded(element: any) {
    this.onAddedSource.next(element);
  }

  protected emitOnChanged(action: string) {
    this.getElements().then((elements) => this.onChangedSource.next({
      action,
      elements,
      paging: this.getPaging(),
      filter: this.getFilter(),
      sort: this.getSort(),
    }));
  }

  // This method is a replica of emitOnChanged method, only
  // difference being it doesnt apply filtering on rows which are
  // newly added as they get filtered out and then add new operation fails
  protected emitOnChangedWithCustomFilter(action: string, isNewRow?: boolean, newRowRemoved?: boolean) {
    this.getElementsWithCustomFilter().then((elements) => this.onChangedSource.next({
      action,
      elements,
      paging: this.getPaging(),
      filter: this.getFilter(),
      sort: this.getSort(),
      newRow: isNewRow,
      newRowRemoved
    }));
  }
}
